import { imsAuthService } from "./ims-auth-service";
import { getSafeReturnUrl } from "./return-url";

/** Явный вход через IMS по действию пользователя; возврат — только на страницу приложения. */
export const startSignIn = (returnUrl?: string | null): void => {
  imsAuthService.redirectToLogin(getSafeReturnUrl(returnUrl));
};
